// frontend/src/components/games/tictactoe/tictactoeConstants.ts

export type Player = 'X' | 'O';
export type TicTacToeMode = 'two-player' | 'vs-ai';

export const WIN_LINES: number[][] = [
  [0, 1, 2], [3, 4, 5], [6, 7, 8], // yatay
  [0, 3, 6], [1, 4, 7], [2, 5, 8], // dikey
  [0, 4, 8], [2, 4, 6],            // çapraz
];
